import {Injectable} from '@angular/core';
import {InsoleElementDefinitionModel} from "./insoleElementDefinition.model";
import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {InsoleElementDefinitionSummaryConverter} from "./insoleElementDefinitionSummary.converter";
import {LovValueSummaryConverter} from "../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class InsoleElementDefinitionConverter extends HttpModelConverter<InsoleElementDefinitionModel> {

    constructor(private summaryConverter: InsoleElementDefinitionSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): InsoleElementDefinitionModel {
        return new InsoleElementDefinitionModel();
    }

    protected enrichObject(result: InsoleElementDefinitionModel, src: InsoleElementDefinitionModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.category = this.lovValueSummaryConverter.convert(src.category);
        result.position = this.lovValueSummaryConverter.convert(src.position);
    }

}
